import { css, html } from 'react-strict-dom';
import { Api } from 'src/api';
import { Model } from 'src/models';

import DashboardSection from './DashboardSection';
import SkillBadge from './SkillBadge';
import TicketList from './TicketList';
import TicketRow from './TicketRow';

type Props = {
  title: string;
  tasks: ReadonlyArray<Api.DailyTask.V>;
  /** Whose day this is, which decides the skills each row is badged with. */
  userId: string;
  emptyMessage: string;
  collapsible?: boolean;
  isCompleted?: boolean;
};

export default function DailyTasksSection({
  title,
  tasks,
  userId,
  emptyMessage,
  collapsible,
  isCompleted,
}: Props) {
  return (
    <DashboardSection
      title={title}
      count={tasks.length}
      collapsible={collapsible}
    >
      <TicketList isEmpty={tasks.length === 0} emptyMessage={emptyMessage}>
        {tasks.map((task) => (
          <TicketRow
            key={task.ticket.id}
            ticket={task.ticket}
            isCompleted={isCompleted}
            action={
              <html.span style={styles.skills}>
                {Model.TicketSkill.filterForUser(
                  task.ticket.skills,
                  userId
                ).map((skill) => (
                  <SkillBadge key={skill.id} skill={skill} />
                ))}
              </html.span>
            }
          />
        ))}
      </TicketList>
    </DashboardSection>
  );
}

const styles = css.create({
  skills: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
  },
});
